module.exports = __webpack_public_path__ + "img/Women and Investing Infographic.b42a08dc.jpg";